export const LeadsPoolViewEnum = {
  contact: 'contact',
  lease: 'lease',
  sales: 'sales',
};
